<button *ngFor="let button of buttons" color="primary" mat-stroked-button class="ea-custom-button"
    [ngStyle]="buttons.length === 1 ? {'border-radius': '4px'} : {}" [disabled]="isDisabled(button)"
    [matTooltip]="(button?.tooltip || '') | titlecase" (click)="onClick(button)">
    <span *ngIf="button?.label" style="color: rgba(0, 0, 0, 0.87);">{{button?.label}}</span>
    <mat-icon *ngIf="button?.icon">{{button?.icon}}</mat-icon>
</button>